import { render } from "./EarLobeRepairContentPtBR.vue?vue&type=template&id=c25c7536"
import script from "./EarLobeRepairContentPtBR.vue?vue&type=script&lang=js"
export * from "./EarLobeRepairContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__